module.exports = __webpack_public_path__ + "img/dp-sy-lm21.098d32e4.png";